import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Loader from "Components/Loader/loader";
import axios from "axios";
import { Password } from "primereact/password";
import { InputText } from "primereact/inputtext";
import "./ConnexionEntrepriseForm.scss";
import OubliMotDePasse from "../OubliMotdePasse/OubliMotDePasse";

const ConnexionEntrepriseForm = () => {
  const defaultValues = {
    username: "",
    password: "",
  };

  // variables du formulaire
  const {
    control,
    formState: { errors },
    handleSubmit,
    // reset,
    setError,
  } = useForm({ defaultValues });

  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [visibleForgotPassword, setVisibleForgotPassword] = useState(false);
  /**
   * Affichage d'une erreur si nécessaire dans le formulaire
   * @param {String} name nom du champ
   * @returns {JSX.Element}
   */
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  function navigateToRecruteur() {
    window.location.href = process.env.REACT_APP_RECRUTEUR_PORTAIL_URL;
  }

  const loginSubmission = (data) => {
    var apiResponse = axios
      .post(
        `${process.env.REACT_APP_RECRUTEUR_API_URL}/api/login_check`,
        data,
        {
          headers: {
            accept: "application/json",
          },
        }
      )
      .catch((error) => {
        apiResponse = error;
      })
      .then((response) => {
        apiResponse = response;
      })
      .finally(() => {
        setIsLoggingIn(false);
        if (
          apiResponse &&
          apiResponse.status === 200 &&
          apiResponse.data.token
        ) {
          document.cookie = `token=${apiResponse.data.token}; path=/; domain=.unif.fr; secure; SameSite=Lax;`;
          navigateToRecruteur();
        } else {
          setError("password", {
            type: "manual",
            message: "Identifiants incorrects",
          });
        }
      });
  };

  return (
    <React.Fragment>
      {visibleForgotPassword ? (
        <OubliMotDePasse
          visible={visibleForgotPassword}
          setVisible={setVisibleForgotPassword}
        />
      ) : (
        <form className="login__form" onSubmit={handleSubmit(loginSubmission)}>
          <div className="login__form__field">
            <h4 htmlFor="email">Adresse email</h4>
            <Controller
              name="username"
              control={control}
              rules={{
                required: "L'email est obligatoire",
              }}
              render={({ field }) => (
                <InputText
                  {...field}
                  placeholder="Adresse email"
                  className="login__form__field-email"
                  type="email"
                />
              )}
            />
            {getFormErrorMessage("email")}
          </div>
          <div className="login__form__field">
            <h4 htmlFor="password">Mot de passe</h4>
            <Controller
              name="password"
              control={control}
              rules={{
                required: "Le mot de passe est obligatoire",
              }}
              render={({ field }) => (
                <Password
                  {...field}
                  placeholder={"Mot de passe"}
                  className="login__form__field-password"
                  feedback={false}
                />
              )}
            />
            {getFormErrorMessage("password")}
          </div>
          <span
            className="login__form__forgot__password"
            onClick={() => setVisibleForgotPassword(true)}
          >
            Mot de passe oublié ?
          </span>
          <div className="login__form__button">
            <BtnBleu
              btnAction={() => {
                setIsLoggingIn(true);
              }}
            >
              {isLoggingIn ? <Loader /> : "Se connecter"}
            </BtnBleu>
          </div>
        </form>
      )}
    </React.Fragment>
  );
};

export default ConnexionEntrepriseForm;
